import { jsx } from "react/jsx-runtime";
import EditIcon from "@mui/icons-material/Edit";
import { validateTidalLicense } from "../../base/index.js";
function Edit(props) {
  return /* @__PURE__ */ jsx(
    EditIcon,
    {
      "data-testid": "Edit",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Edit",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
Edit.tidalIconMeta = {
  categories: "common,navigation",
  name: "Edit"
};
validateTidalLicense();
export {
  Edit
};
//# sourceMappingURL=Edit.js.map
